<p-card [header]="isEdit ? 'Nutzer Bearbeiten' : 'Nutzer Hinzufügen'">
  @if (loading) {
    <div class="d-flex justify-content-center">
      <p-progressSpinner strokeWidth="5"></p-progressSpinner>
    </div>
  }
  @if (!loading) {
    <p-tabs value="0" scrollable>
      <p-tablist>
        <p-tab value="0">
          <app-overview-tab-header [form]="mainForm" [hasSaved]="hasSaved" text="Stammdaten"/>
        </p-tab>
        <p-tab value="1">
          <app-overview-tab-header [form]="statusForm" [hasSaved]="hasSaved" text="Status"/>
        </p-tab>
        <p-tab value="2">Intern</p-tab>
        <p-tab value="3">Angehörige</p-tab>

        @if (isEdit) {
          <p-tab value="4">Fehlzeiten</p-tab>
          <p-tab value="5">Historie</p-tab>
          <p-tab value="6">Notiz</p-tab>
        }

        @if (isEdit && customer?.id && authService.user()!.role.id === RoleEnum.Admin) {
          <p-tab value="7">Sozialberatung</p-tab>
        }

        @if (isEdit && customer?.id) {
          <p-tab value="8">Dateien</p-tab>
        }
      </p-tablist>

      <p-tabpanels>
        <p-tabpanel value="0">
          <app-main-form [mainForm]="mainForm"/>
        </p-tabpanel>

        <p-tabpanel value="1">
          <app-status-form [statusForm]="statusForm"/>
        </p-tabpanel>

        <p-tabpanel value="2">
          <app-internal-form [internalForm]="internalForm"/>
        </p-tabpanel>

        <p-tabpanel value="3">
          <app-member-form [memberForm]="memberForm"/>
        </p-tabpanel>

        @if (isEdit) {
          <p-tabpanel value="4">
            <app-absences [customerId]="customer!.id!"/>
          </p-tabpanel>
          <p-tabpanel value="5">
            <app-history [customerId]="customer!.id!"/>
          </p-tabpanel>
          <p-tabpanel value="6">
            <app-comment [customerId]="customer!.id!"/>
          </p-tabpanel>
        }

        @if (isEdit && customer?.id && authService.user()!.role.id === RoleEnum.Admin) {
          <p-tabpanel value="7">
            <app-social-support [customerId]="customer!.id!"/>
          </p-tabpanel>
        }

        @if (isEdit && customer?.id) {
          <p-tabpanel value="8">
            <app-attachments [customerId]="customer!.id!"/>
          </p-tabpanel>
        }
      </p-tabpanels>
    </p-tabs>

  }
</p-card>
<p-card class="mt-2">
  <div class="d-flex justify-content-end">
    <p-button (click)="router.navigate(['customers'])" severity="secondary" [outlined]="true" label="ABBRECHEN"
              class="me-2"></p-button>
    <p-button (click)="save()" label="SPEICHERN" icon="pi pi-save"></p-button>
  </div>
</p-card>
